export enum LicenseType {
  Plus = "Plus",
  Enterprise = "Enterprise",
  Free = "Free",
}
